/**
 * @module app.track.Profile
 */
import appTrackProfileService from '../track/ProfileService.js';


class Controller {
  /**
   * @ngInject
   * @param {jQuery} $element
   * @param {angular.Scope} $scope
   * @param {app.track.ProfileService} appTrackProfileService
   * @param {app.track.service} appTrackService
   */
  constructor($element, $scope, appTrackProfileService, appTrackService) {
    /**
     * @private
     */
    this.element_ = $element;

    /**
     * @private
     */
    this.$scope_ = $scope;

    /**
     * @private
     */
    this.trackProfileService_ = appTrackProfileService;

    /**
     * @private
     */
    this.trackService_ = appTrackService;

    /**
     * @export
     * @type {string}
     */
    this.type;

    /**
     * @private
     * @type {Function}
     */
    this.stopWatchingForRefresh_;
  }

  refreshWhenNeeded_() {
    const detailed = this.type === 'detailed';
    const refresh = () => this.trackProfileService_.refreshD3Profile(detailed);

    let previousWidth = 0;
    const div = this.element_.get(0).firstElementChild;
    const intervalId = setInterval(() => {
      if (div.clientWidth !== previousWidth) {
        previousWidth = div.clientWidth;
        refresh();
      }
    }, 500);

    const trackService = this.trackService_;
    const watchers = [
      () => clearInterval(intervalId),
      this.$scope_.$watch(() => trackService.selectedTrack, refresh),
      this.$scope_.$watchCollection(() => trackService.selectedTrack ? trackService.selectedTrack.properties : null, refresh),
      this.$scope_.$watchCollection(() => trackService.selectedTrackPois, refresh)
    ];
    this.stopWatchingForRefresh_ = () => {
      watchers.forEach(unWatcher => unWatcher());
      this.stopWatchingForRefresh_ = null;
    };
  }

  $onInit() {
    console.assert(this.type === 'light' || this.type === 'detailed');
    const profileElement = this.element_.get(0).firstElementChild;
    profileElement.id = `${this.type}_track_profile`;
    profileElement.classList.add(`${this.type}-track-profile`);
    this.refreshWhenNeeded_();
  }

  $onDestroy() {
    this.stopWatchingForRefresh_();
  }
}


/**
 * @type {!angular.Component}
 */
const component = {
  controller: Controller,
  bindings: {
    type: '@'
  },
  template: '<div></div>'
};

const name = 'appTrackProfile';
export default angular.module(name, [appTrackProfileService.name])
  .component(name, component);
